import {Component, Input, OnChanges, OnInit} from '@angular/core';

enum UserCardSizeE {
  BASE = 'base',
  SMALL = 'sm',
  LARGE = 'lg'
}

interface UserCardI {
  title: string;
  subtitle: string;
  subtitleTip?: string;
  image: string;
  icon?: string;
  badge?: string;
  badgeColor?: string;
}

interface UserCardConfigI {
  border: boolean;
  shadow: boolean;
  size: UserCardSizeE,
}

@Component({
  selector: 'nw-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class NewellUserAvatarComponent implements OnInit, OnChanges {
  @Input() public user: UserCardI;
  @Input() public disabled: boolean;
  @Input() public config: UserCardConfigI;

  constructor() { }

  ngOnInit(): void {}

  ngOnChanges() {
   if (!this.user) {
     this.user = {
       image: 'assets/images/profile-images/profile-150x150.png',
       title: 'Social Champ',
       subtitle: 'email@socialchamp.io',
     };
   }

   if (!this.config) {
     this.config = {
       border: false,
       shadow: false,
       size: UserCardSizeE.BASE,
     };
   }

   if (!this.disabled === undefined) {
     this.disabled = false;
   }
  }

  imageFallback() {
    this.user.image = 'assets/images/profile-images/profile-150x150.png';
  }

}
